// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1g0E3","colBig":"styles_colBig__josrK","colSmall":"styles_colSmall__3kPbc"};